<div *ngIf="!loader" fxLayout="column" class="layout-padd" fxFlexFill [ngStyle]="{'max-height.px': innerHeight}">

    <!--card  -->

    <div fxLayout="column" fxLayoutGap="20px" fxLayoutGap.xs="10px" class="layout-padd scrolled heig_  ">

        <div fxLayout="row" fxLayoutAlign="space-between center">
            <span class="mat-headline boldest">{{'PaymentMethodCardComponent.card'|translate}}</span>
        </div>


        <!-- Boucle sur card -->

        <div fxLayout="column" fxLayoutGap="10px"
            *ngIf="(currSM.enable_online_payment> 0 || currSM.payment_type=='online' )   && currPOS.stripe_account && clientCards && clientCards.length>0">

            <div fxLayout="row" *ngFor="let card of clientCards; let index = index;" (click)="selectStripeCard(card)"
                class="fake-form-field-endorder clicked">

                <!-- mat-radio-button -->
                <div fxLayout="row" fxLayoutAlign="end center">
                    <mat-radio-button color="primary" [value]="card.paiment_type"
                        [checked]="selectedCard && card?  selectedCard.created === card.created:null">
                    </mat-radio-button>
                </div>

                <!-- card -->
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.xs="space-between center"
                    fxLayoutGap="10px" fxFlex>

                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <img src="{{card.card.logo_src}}" class="rad-bord "  class="h-10">

                        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap.xs="10px">
                            <span class="mat-subheading-1 boldest">{{card.card.brand | capitalize}}</span>
                            <span class="mat-subheading-2" style="color:grey" fxHide fxShow.xs
                                *ngIf="clientCards.length>1">**** {{card.card.last4}}</span>
                        </div>
                    </div>

                    <span class="mat-subheading-2" style="color:grey" fxHide fxShow.xs *ngIf="clientCards.length<2">****
                        {{card.card.last4}}</span>
                    <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** ****
                        {{card.card.last4}}</span>
                </div>
                <!-- set favorite -->
                <div fxLayoutAlign="center center" class="layout-padd" style="margin-top: -5px;"
                    (click)="setDefaultPaymentStripeMethod(card,$event);$event.stopPropagation();"
                    *ngIf="clientCards.length>1">
                    <mat-icon fontSet="material-icons-outlined"
                        *ngIf=" !defaultStripePayMethod|| defaultStripePayMethod && defaultStripePayMethod.id!=card.id">star_rate</mat-icon>
                    <mat-icon *ngIf="defaultStripePayMethod && defaultStripePayMethod.id==card.id"
                        style="color:rgba(245, 196, 1, 0.897);">star_rate
                    </mat-icon>
                </div>


                <!--menu delete -->
                <div fxLayoutAlign="center center" class="layout-padd" style="margin-top: -5px;">
                    <mat-icon mat-icon-button class="dark-ico" [matMenuTriggerFor]="menu"
                        (click)="$event.stopPropagation();">
                        more_vert
                    </mat-icon>

                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            (click)="openDialDeletePaymentMethod(card, index); $event.stopPropagation();"
                            angulartics2On="click" angularticsAction="openDialDeletePaymentMethod"
                            angularticsCategory="paymentMethods">{{"basket.delete" |
                            translate}}
                        </button>
                    </mat-menu>
                </div>


            </div>

        </div>







    </div>


    <!--  btn bottom -->

    <div class="layout-padd positionBottom" fxLayoutGap="10px" fxflex>

        <button mat-stroked-button class="dark-ico rounded-button" fxFlex (click)="closeDial('cancel')">
            <span class="mat-title">{{ "cancel_button"|translate}}</span>
        </button>


        <button mat-stroked-button class="primary rounded-button" fxFlex (click)="closeDial()">
            <span class="mat-title">{{"validate-button"|translate}}</span>
        </button>

    </div>


</div>


<app-popup-loader [flagLoading]="loader" [size]="30"></app-popup-loader>
